import type { ModifierEffect, EffectDataReRoll } from "~/types"

interface EffectReRollData {
  effect: ModifierEffect & { data: EffectDataReRoll }
  ellipsis: string
}

export default function effectReRoll(data: EffectReRollData): {
  description: string
} {
  const { effect, ellipsis } = data
  let description = ""

  if (effect.data.application) {
    description = "Re-roll "
    // Roll to re-roll.
    const rollToReRoll = effect.data.application.title
    // Singular or plural result.
    let s = ""

    // Limit.
    if (effect.data.limit.key === "single") {
      description += "one "
    }
    if (effect.data.limit.key === "none") {
      description += "all "
      s += "s"
    }

    // Result to re-roll.

    if (!effect.data.resultToReRoll) {
      description += ellipsis
    }
    // All possible failure(s)
    if (effect.data.resultToReRoll?.key === "allPossibleFailures") {
      description += `possible failed ${rollToReRoll}${s}`
    }
    // Failed
    if (effect.data.resultToReRoll?.key === "failed") {
      description += `failed ${rollToReRoll}${s}`
    }
    // Single.
    if (effect.data.resultToReRoll?.key === "single") {
      description += `${rollToReRoll} result${s} of `
      if (effect.data.valueSingle) {
        description += effect.data.valueSingle
      } else {
        description += ellipsis
      }
    }
    // Range.
    if (effect.data.resultToReRoll?.key === "range" && effect.data.valueRange) {
      const min = effect.data.valueRange[0]
      const max = effect.data.valueRange[1]
      description += `${rollToReRoll} `
      if (min === max) {
        description += `result${s} of ${min}`
      } else {
        // NOTE: This uses an en dash, not a hyphen.
        description += `result${s} of ${min}–${max}`
      }
    }
  }

  return {
    description,
  }
}
